export default "__VITE_ASSET__BJWsoEQ7__"